import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { objectEntriesForFields } from './object-entries-for-fields.js'

export function objectValueForFields(fields: SchemaField[]): string {
  return `{${objectEntriesForFields(fields).join(', ')}}`
}
